import type { ListingResponse } from '@certi/shared/types'

const DEFAULT_BASE = 'https://certi-prod-bucket-uploads.s3.us-east-1.amazonaws.com/media'

export function getMockListings(baseUrl?: string): ListingResponse[] {
  const base = (baseUrl || import.meta.env.VITE_S3_PUBLIC_MEDIA_BASE_URL || DEFAULT_BASE).replace(/\/$/, '')

  const now = new Date().toISOString()

  const brady: ListingResponse = {
    id: 'mock-brady-jersey',
    title: 'Tom Brady Hand Signed Tampa Bay Buccaneers Jersey #12 Autographed COA',
    description: 'Hand-signed jersey with COA. Premium collectible from a legendary career.',
    price: '585.00',
    category: 'CLOTHING',
    condition: 'GAME_WORN',
    sportType: 'FOOTBALL',
    mediaUrls: [`${base}/brady3.png`],
    status: 'LIVE',
    slug: 'tom-brady-jersey',
    createdAt: now,
    updatedAt: now,
    playerName: 'Tom Brady',
    teamOrClub: 'Tampa Bay Buccaneers',
    leagueOrEvent: 'NFL',
    dateOrSeason: '2021',
    size: 'L',
    tags: ['AUTOGRAPHED']
  }

  const lagway: ListingResponse = {
    id: 'mock-dj-lagway-helmet',
    title: 'DJ Lagway Autographed FL Gators Helmet (Beckett)',
    description: 'Autographed Florida Gators helmet with Beckett authentication.',
    price: '652.99',
    category: 'EQUIPMENT',
    condition: 'PLAYER_ISSUED',
    sportType: 'FOOTBALL',
    mediaUrls: [`${base}/lagway1.png`],
    status: 'LIVE',
    slug: 'dj-lagway-helmet',
    createdAt: now,
    updatedAt: now,
    playerName: 'DJ Lagway',
    teamOrClub: 'Florida Gators',
    leagueOrEvent: 'NCAA',
    dateOrSeason: '2023',
    size: null,
    tags: ['AUTOGRAPHED']
  }

  // Generate 4 more variants of each to have several listings (5x total per type)
  const clones: ListingResponse[] = []
  for (let i = 2; i <= 5; i++) {
    const minutesAgo = i * 5
    const ts = new Date(Date.now() - minutesAgo * 60_000).toISOString()

    clones.push({
      ...brady,
      id: `${brady.id}-${i}`,
      slug: brady.slug ? `${brady.slug}-${i}` : null,
      title: `${brady.title} (Edition ${i})`,
      price: (Number(brady.price) + i * 10).toFixed(2),
      createdAt: ts,
      updatedAt: ts,
    })

    clones.push({
      ...lagway,
      id: `${lagway.id}-${i}`,
      slug: lagway.slug ? `${lagway.slug}-${i}` : null,
      title: `${lagway.title} (Edition ${i})`,
      price: (Number(lagway.price) + i * 10).toFixed(2),
      createdAt: ts,
      updatedAt: ts,
    })
  }

  return [brady, lagway, ...clones]
}

export function getMockListingBySlug(slug: string, baseUrl?: string): ListingResponse | null {
  const items = getMockListings(baseUrl)
  // Exact match first
  const exact = items.find(i => i.slug === slug)
  if (exact) return exact
  // Fallback: match base slug without numeric suffix
  const baseSlug = slug.replace(/-(\d+)$/, '')
  return items.find(i => i.slug === baseSlug) || null
}
